import { UseFormRegister } from "react-hook-form";
import classNames from "classnames";
import useRegisterPropOrFromContext from "./useRegisterPropOrFromContext";

export default function Checkbox({
  name,
  register,
  label,
  disabled = false,
  className,
  required,
  value,
}: {
  name: string;
  label: string;
  register?: UseFormRegister<any>;
  disabled?: boolean;
  className?: string;
  required?: boolean | string;
  value?: string;
}) {
  register = useRegisterPropOrFromContext(register);

  return (
    <label
      className={classNames("checkbox gap-2 items-center", className, {
        "text-muted": disabled,
      })}
    >
      <input
        type="checkbox"
        {...register(name, { required })}
        value={value}
        disabled={disabled}
      />
      {label}
    </label>
  );
}
